export default [
    {
        name: '__slot:system_notifications__title',
        sortField: 'title',
        type: 'string',
        useInFilter: false
    },
    {
        name: 'startedAt',
        sortField: 'startedAt',
        type: 'dateRange',
        useInFilter: false,
        callback: 'systemNotificationsDate'
    }
];
